import React, {useContext, useState} from 'react'
import {AuthContext} from '../context/AuthContext'
import {getAuthHeader, getLocalStorageItem, objectLang, setErrorWindow, setLocalStorageItem} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import config from "../config.json"
import {ModalUpdateCardBankClass} from "../elements/ModalUpdateCardBankClass"
import {useHttp} from "../hooks/http.hook"
import {useNavigate} from "react-router-dom"

export const UpdateCardBankPage = () => {
    setLocalStorageItem('page', 'UpdateCardBankPage')
    const lang = objectLang().language
    const l = lang.lang
    const auth = useContext(AuthContext)
    const navigate = useNavigate()
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const {loading, request} = useHttp()
    const urlParams = new URLSearchParams(window.location.search)
    const cardId = urlParams.get('cardId')

    const closeHandler = () => {
        window.location.replace(`/${l}/money/settings`)
    }

    const updateCardHandler = async (object) => {
        if (!object['name'] || !object['type'] || !object['currency'] || !object['date']) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                '',
                591,
                '',
                '',
                `replaceTo /${l}/money/settings`
            ))
            return
        }
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        object.cardId = cardId
        object.lang = l
        try {
            const data = await request(
                `${host}/api/money/settings/update-card`,
                'POST',
                object,
                {
                    Authorization: getAuthHeader(auth)
                })
            if (data.status > 201) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                navigate(`/${l}/money/settings`)
            }

        } catch (e) {
            navigate(`/${l}/money/settings`)
        }
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <ModalWin data={dataModal}/>
        )
    }

    const cardDetails = getLocalStorageItem(cardId)

    const data = {
        title: lang.body.cardBankPage.titleUpdate,
        desc: lang.body.cardBankPage.descUpdate,
        btnOKColor: 'success',
        btnCancelColor: 'secondary',
        btnOK: lang.body.cardBankPage.btnUpdate,
        btnCancel: lang.body.cardBankPage.btnCancel,
        contentName: cardDetails.name,
        contentType: cardDetails.type,
        contentDate: cardDetails.dateExp,
        contentCurrency: cardDetails.currency,
        contentDefault: cardDetails.defaultType,
    }

    return (
        <>
            <ModalUpdateCardBankClass
                lang={lang}
                updateCardHandler={updateCardHandler}
                closeHandler={closeHandler}
                data={data}
            />
        </>
    )
}